export enum StageInfluenceTabs {
    Campaign = 'campaign',
    CampaignType = 'campaignType'
}
